import LocalizationSettings from "./LocalizationSettings";


// use entities extending this interface to create MediumSettings
export interface LocationSettingsDataProps {
    lang:string;
    localizationSettings:LocalizationSettings
}

class MediumSettings {
    // each key represents a different lang this app supports
    // i.e. 'es' ,  'en' , 'fr' ...etc
    // key is dynamic to make sure this scales as we add support for more langs
    [key: string]: LocalizationSettings | string | null;

    // constructor has two arguments:
    //  1- an array of LocationSettingsDataProps to populate the dynamic keys for instance
    //  2- a medium indicator
    constructor(
        localizationSettings: Array<LocationSettingsDataProps>,
    ) {
        localizationSettings.forEach((localizationSetting:LocationSettingsDataProps) => {
                this[localizationSetting.lang] =  localizationSetting.localizationSettings
        });
    }
  }
  
  export default MediumSettings;
  